/**
 * PageSearch JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class PageSearch
 */
class PageSearch {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.searchForm       = $( '#js-page-search-form' );
        this.searchInput      = $( '#js-page-search-input' );
        this.searchButton     = $( '#js-page-search-button' );
        this.loader           = $( '#js-page-search-loader' );
        this.resultsContainer = $( '#js-page-search-results-container' );
        this.resultsSection   = $( '#js-page-search-results-section' );
        this.results          = $( '#js-page-search-results' );
        this.errorContainer   = $( '#js-page-search-error' );
        this.filters          = $( '.js-page-search-filter' );

        // Use localized strings from the theme.
        this.strings = {
            'errortext': themeData.themeStrings.search.errors.general
        };
    }

    /**
     * All events of the class.
     * @return {void}
     */
    events() {

        // Bind a handler to the search text input box and fire a method when the value changes.
        $( this.searchForm ).on( 'submit', ( e ) =>  {

            this.prepareSearch( e, this.searchInput.val(), false );

        });

        // Set a timeout variable to fire search only after user stops typing.
        let timeout = null;

        // Bind a handler to the search text input box and fire a method when the value changes.
        $( this.searchInput ).on( 'input', () =>  {

            // Clear the timeout if there was any set so that the method fires
            // only when the final timeout time has passed.
            clearTimeout( timeout );
            timeout = setTimeout( () => {
                this.changeButton( this.searchInput.val() );
            }, 250 );

        });

        // Loop through filters and bind a click handler to each of them.
        this.filters.each( ( index, filter ) => {

            // Bind a click handler to each filter.
            $( filter ).on( 'click', ( e ) =>  {

                this.filters.removeClass( 'js-active' );
                $( filter ).addClass( 'js-active' );
                this.prepareSearch( e, false, filter.dataset.postType );

            });

        });

    }

    /**
     *  This changes the button when there's text in the input field.
     *
     */
    changeButton( inputText ) {

        // This trims whitespace from the input.
        const formattedInputText = $.trim( inputText ).toLowerCase();

        // If the text is longer than two characters, modify the search button.
        if ( formattedInputText.length > 2 ) {
            this.searchButton.addClass( 'js-active' );
        } else {
            this.searchButton.removeClass( 'js-active' );
        }
    }

    /**
     * This method is run when the page is loaded and if
     * there's both search parameters, this runs the search query.
     */
    parseGetParameters() {
        const searchWord = Theme.Common.getUrlParameter( 'search' );
        const postType   = Theme.Common.getUrlParameter( 'type' );

        if ( searchWord ) {
            this.searchInput.val( searchWord );
        }

        if ( postType ) {
            this.filters.each( ( index, filter ) => {
                if ( filter.dataset.postType === postType ) {
                    this.filters.removeClass( 'js-active' );
                    $( filter ).addClass( 'js-active' );
                }
            });
        }
    }

    /**
     * This prepares the inputs for the search.
     *
     * @param {event} e The event.
     * @param {string} inputValue The value from the input field.
     * @param {string} postType The data attribute from the chosen post type filter.
     */
    prepareSearch( e, inputValue, postType ) {

        // Stop the event only if it was passed to the method.
        if ( e ) {

            // Stop the event with the static method from the Common class.
            Theme.Common.stop( e );
        }


        // If there's no input value given, fetch it from the input field.
        if ( inputValue === false ) {
            inputValue = this.searchInput.val();
        }

        // If there's no post type filter, loop through all
        // filters get the data attribute from the active one.
        if ( postType === false ) {

            this.filters.each( ( index, filter ) => {
                if ( $( filter ).hasClass( 'js-active' ) ) {
                    postType = filter.dataset.postType;
                }
            });
        }

        this.getResults( inputValue, postType );
    }

    /**
     *  This gets the search results
     *
     */
    getResults( inputValue, postType ) {

        // This trims whitespace from the input.
        const searchword = $.trim( inputValue );

        // This trims whitespace from the postType.
        const posttype = $.trim( postType );

        // If the text is longer than two characters, do a search.
        if ( searchword.length > 2 && postType.length > 0 ) {

            // Empty possible old results or errors and show the loader.
            this.resultsSection.removeClass( 'js-hidden' );
            this.errorContainer.addClass( 'js-hidden' );
            this.results.addClass( 'js-hidden' );
            this.loader.removeClass( 'js-hidden' );

            dp( 'PageSearch/search', {

                partial: 'pagesearchresults',
                'args': {
                    searchword,
                    posttype
                },

                success: ( data ) => {

                    // Hide the loader and show the data rendered with a correct dust partial
                    this.loader.addClass( 'js-hidden' );
                    this.results.removeClass( 'js-hidden' );
                    this.results.html( data );

                    // This gets the instance of the mail parser class
                    // and runs its parsing method for result's mailto-links.
                    const parser = Theme.getController( 'MailtoParser' );
                    parser.cache();
                    parser.parseMailtoLink();

                    // This inits galleries for possible machine search results.
                    const galleryParser = Theme.getController( 'Common' );
                    galleryParser.cache();
                    galleryParser.initGalleries();

                },

                // If the call itself wasn't successful, show an error message.
                error: ( error ) => {
                    this.loader.addClass( 'js-hidden' );
                    this.errorContainer.removeClass( 'js-hidden' );
                    this.errorContainer.html( '<span>' + this.strings.errortext + '</span>' );
                    console.log( error );
                }

            });
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.parseGetParameters();
        this.changeButton( this.searchInput.val() );
        this.prepareSearch( false, false, false );
        this.events();
    }
}

// Export the class reference.
module.exports = PageSearch;



// WEBPACK FOOTER //
// ./assets/scripts/pagesearch.js